export default {

  // actions / headers
  active: 'Active {{value}}',
  apply: 'Apply {{value}}',
  add: 'Add {{value}}',
  addNew: 'Add New {{value}}',
  age_range: 'Age Range',
  apps: 'Apps',
  app_store: 'Apps Store',
  cancel: 'Cancel {{value}}',
  change: 'Change {{value}}',
  create: 'Create {{value}}',
  click_to_browse: 'Click to browse',
  campaign: 'Campaign {{value}}',
  continue: 'Continue',
  confirmDelete: 'Are you sure you want to delete {{value}}?',
  customize: 'Customize',
  drag_and_drop: 'Drag&Drop {{value}}',
  delete: 'Delete {{value}}',
  drop_a_file: 'Drop a file',
  edit: 'Edit {{value}}',
  enter_here: 'Enter {{value}} here',
  genre: 'Genre',
  income: 'Income',
  logic: '{{value}} Logic',
  new: 'New {{value}}',
  requestAccessToGameDeveloper: 'Request Access to App Developer',
  requestAccessTo: 'Request Access to',
  selectGameDeveloper: 'Select an App Developer',
  send: 'Send',
  approve: 'Approve',
  reject: 'Reject',
  accessRequestTitle: 'App Developer Access Request',
  accessRequestMessage: 'The user {{email}} has requested access to {{developer}}.',
  grantAccessQuestion: 'Would you like to grant access?',
  percentage: 'Percentage',
  preview: 'Preview {{value}}',
  remove: 'Remove {{value}}',
  save: 'Save {{value}}',
  select: 'Select {{value}}',
  universal: 'Universal',
  selected: 'Selected',
  set: 'Set {{value}}',
  settings: '{{value}} Settings',
  size: '{{value}} Size',
  status: '{{value}} Status',
  reset: 'Reset {{value}}',
  top: 'Top {{value}}',
  update: 'Update {{value}}',
  loading: 'Loading...',
  invalidOrExpiredLink: 'Invalid or expired link',
  unselect: 'Unselect',
  view: 'View {{value}}',
  listOf: 'List of {{value}}',
  listOfGames: 'Sellers in the Marketplace',
  listOfGames_help: 'List of Apps that sell their users in the Marketplace.',
  listOfApps: 'Other Apps Users Play',
  listOfApps_help: 'Other Apps Users Play',

  // states
  $state: {
    accountSettings: 'Account Settings',
    analytics: 'Analytics',
    dashboard: 'Dashboard',
    revenue: 'Revenue',
    login: 'Login',
    logout: 'Logout',
    app: {
      admin: {
        games: {
          index: 'Apps Management',
          new: 'Add New App',
          edit: 'Edit {{name}} Settings'
        },
        gameDevelopers: {
          index: 'App Developers Management',
          new: 'Add New App Developer',
          edit: 'Edit {{name}} Settings'
        },
        users: {
          index: 'Users Management',
          new: 'Add New User',
          edit: 'Edit {{name}} Settings'
        },
        bidPrices: {
          edit: 'Search/Edit Bid Prices'
        }
      },
      analytics: {
        index: '{{name}} Analytics',
        edit: 'Edit {{name}} Settings',
        explore: 'Explore {{name}} Analytics'
      },
      campaigns: {
        index: 'Campaign Management',
        new: 'Create Campaign',
        edit: 'Edit Campaign ({{id}})',
        show: 'Campaign Dashboard ({{id}})',
        explore: 'Explore Campaign ({{id}})'
      },
      cohorts: {
        show: 'Cohorts ({{id}})'
      },
      explore: {
        show: 'Explore Users ({{id}})'
      },
      marketplace: {
        index: 'Marketplace'
      },
      games: {
        index: 'Main Dashboard',
        revenue: 'Revenue',
        new: 'Add New App',
        edit: 'Edit {{name}} Settings'
      },
      segments: {
        index: 'Segments Management',
        showEngage: {
          show: 'Engagement Segment Dashboard ({{id}})'
        },
      }
    },
    password: {
      edit: 'Edit password',
      forgot: 'Reset password'
    }
  },

  $rule: {
    $and: 'AND',
    $or: 'OR',
    $grouped_and: 'GROUPED AND',
    $grouped_or: 'GROUPED OR',
    $in: '=',
    $in_last_days: '=',
    $nin: '!=',
    $nin_last_days: '!=',
    $gt: '>',
    $gte: '>=',
    $lt: '<',
    $lte: '<=',
    $eq: '=',
    $ne: '!=',
    known: 'known',
    unknown: 'unknown',
    engaged: {
      $in: 'In',
      $nin: 'Not in'
    },
    progressHistory: {
      $in: 'In',
      $nin: 'Not in'
    },
    clickHistory: {
      $in: 'In',
      $nin: 'Not in'
    },
    engageHistory: {
      $in: 'In',
      $nin: 'Not in'
    },
    targeted: {
      $in: 'In',
      $nin: 'Not in'
    },
    clicked: {
      $in: 'In',
      $nin: 'Not in'
    },
    date: {
      $in_last_days: 'In',
      $nin_last_days: 'Not in',
      $lt: '<'
    }
  },

  $budget_type: {
    daily: ' / day'
  },

  $fee_type: {
    exchange_fee: {
      label: 'Exchange Fee (%)',
      help: 'Fee for currency exchange. happens only when the Bid-Request is NOT USD$'
    },
    system_fee: {
      label: 'System Fee (%)',
      help: "A fee taken from all GD's, regardless of Contract negotiations"
    },
    additional_fee: {
      label: 'Additional Fee (%)',
      help: 'Use this fee to charge for additional services like Managed Service, Creative Management etc'
    },
    service_fee: {
      label: 'Service Fee (%)',
      help: 'The Tiered fee as negotiated in the contract. The volumes steps represent the monthly budget spend'
    },
    marketplace_rev_share_fee: {
      label: 'Marketplace Rev Share (%)',
      help: 'The Rev-Share terms with a Seller-GD. The percentage defined here is the "YouAppi DSP Share" of the RPI.'
    }
  },

  $fieldConfig: {
    possible_values_population: {
      dynamic: 'update-all-game-field-possible-values-job will add possible values for this key from user profiles',
      fixed: 'update-all-game-field-possible-values-job will NOT add values for this key from user profiles'
    }
  },

  $campaignType: {
    Engagement: 'Engagement CPM {{value}}',
    EngagementCPC: 'Engagement CPC {{value}}',
    EngagementCPA: 'Engagement CPA {{value}}',
    EngagementCPI: 'Engagement CPI {{value}}',

  },
  $campaignAdvertisingType: {
    Reengagement: 'RE',
    UserAcquisition: 'UA',
  },

  $active: {
    true: 'Active',
    false: 'Not Active'
  },

  // errors
  $errors: {
    domain: 'Invalid domain',
    email: 'Invalid email addresses',
    multipleRequired: 'Required',
    maxlength: 'Input too long',
    passwordConfirmation: 'Invalid password confirmation',
    twoDecimalDigits: 'Number may have up to two decimal digits',
    singleEmailAddress: 'Input must be a single email address',
    fourDecimalDigits: 'Number may have up to four decimal digits',
    required: 'Required',
    url: 'Invalid URL',
    numberBetween: 'Input should be between min and max value',
    isInteger: 'Input must be an integer value',
    maxDailyBudgetValue: 'Maximum daily budget is $20,000'
  },

  // notifications
  $notify: {
    apiError: {
      title: 'Something is wrong...',
      message: `{{status}}: {{statusText}}`
    },
    accessRequested: {
      title: 'Request Sent',
      message: 'Your access request has been sent to the admins for approval.'
    },
    accessApproved: {
      title: 'Access Granted',
      message: 'The access request was approved.'
    },
    accessRejected: {
      title: 'Request Rejected',
      message: 'The access request was rejected.'
    },
    loggedIn: {
      title: 'Success!',
      message: 'You have successfully logged in as {{name}}'
    },
    mfaConfigureFailed: {
      title: 'Configuration Failed',
      message: 'Seems like the MFA code is wrong. Please try again or contact your account manager.'
    },
    MfaNeeded: {
      title: 'MFA is Required!',
      message: 'Please enable MFA'
    },
    logInFailed: {
      title: '',
      message: 'Seems like the email or password are wrong. Please try again or contact your account manager.'
    },
    logInBlocked: {
      title: '',
      message: 'Your user has been blocked, please reach out to your CSM.'
    },
    logInForbidden: {
      title: '',
      message: 'Please reach out to the account manager.'
    },
    logInMfaFailed: {
      title: 'Verification Failed',
      message: 'Seems like the MFA code is wrong. Please try again or contact your account manager.'
    },
    resetMfaFailed: {
      title: '',
      message: 'Unable to reset MFA.'
    },
    resetMfaSucceed: {
      title: '',
      message: 'MFA reset successfully'
    },
    resourceAction: {
      title: 'Success!',
      message: 'The {{resourceType}} "{{resourceName}}" was successfully {{actionName}}!'
    },
    creativeForDimensionExists: {
      title: 'Ops, Creative already exists',
      message: `A creative for dimension ('{{dimension}}') already exists. Please choose a different creative size, update the existing Creative or create a new variation.`
    },
    dimensionInvalid: {
      title: 'Wrong dimensions',
      message: `The dimension of the uploaded creative ('{{dimension}}') are not valid. Please check the valid dimensions we support.`
    },
    dimensionInvalidExpected: {
      title: 'Wrong dimensions',
      message: `The dimension of the uploaded creative ('{{dimension}}') are not valid. Expected creative size is ('{{expected}}').`
    },
    fileTypeInvalid: {
      title: 'Ops, Wrong file type',
      message: `'{{type}}' files are not supported.`
    },
    fieldTooLong: {
      title: 'Ops',
      message: `'{{fieldName}}' is too long.`
    },
    campaignActivate: {
      title: 'Please note:',
      message: 'Activating this campaign will set scheduled start date to current date'
    },
    campaignPausing: {
      title: 'Please note:',
      message: 'Pausing this campaign will remove the scheduled start and end dates. You can set them with new dates.'
    },
    gameCampaignsActive: {
      title: 'Please note:',
      message: 'You can’t inactive the app, there are still active campaigns.'
    },
    campaignPausingDueToFutureStartDate: {
      title: 'Please note:',
      message: 'This campaign will be paused. It will restart on the new selected start date.'
    },
    pausedDueToBudgetCampaignActivated: {
      title: 'Oops, cannot activate this campaign',
      message: 'Campaign was paused due to budget reasons'
    },
    campaignActivateImmediate: {
      title: 'Please note:',
      message: 'Activating this campaign has set scheduled start date to current date'
    },
    campaignPausingImmediate: {
      title: 'Please note:',
      message: 'Pausing this campaign removed the scheduled start and end dates.'
    },
    pastDate: {
      title: "Cannot set date",
      message: "Date cannot be in the past"
    },
    pausedDueToBudgetCampaignPaused: {
      title: "Cannot pause immediately",
      message: "Campaign will pause tomorrow"
    },
    willActivateSegment: {
      title: "Please note:",
      message: "Re-activating this campaign will re-activate the targeting segments as well!"
    },
    willActivateSegments: {
      title: "Please note:",
      message: "Re-activating some of the selected campaigns will re-activate their targeting segments as well!"
    },
    updatedDynamicFields: {
      title: 'Success!',
      message: 'Refresh Completed'
    },
  },

  // resources
  audience: 'Audience',
  account: 'Account',
  app: 'App',
  attribution: 'Attribution',
  banner: 'Banner',
  banners: 'Banners',
  campaigns: 'Campaigns',
  channels: 'Channels',
  creativeTypes: 'Creative Types',
  game: 'All',
  games: 'Apps',
  gameDeveloper: 'App Developer',
  gameDevelopers: 'App Developers',
  locale: 'Locale',
  platforms: 'Platforms',
  profile: 'Profile',
  segment: 'Segment',
  segments: 'Segments',
  user: 'User',
  users: 'Users',
  variation: 'Variation',
  variations: 'Variations',

  // fields
  acquisition_source: "Acquisition Source",
  agency: "Agency",
  anonymous: "Anonymous",
  anonymousGame: "Anonymous {{value}} app",
  ago: "AGO",
  apl: "APL",
  aspect_ratio: "Aspect Ratio",
  benchmark: 'Benchmark',
  bidPrice: 'Bid Price',
  blacklist_gds: 'Blacklist GDs',
  lock_user: 'Lock {{value}}',
  unlock_user: 'Unlock {{value}}',
  budget: 'Budget',
  budget_amount: 'Budget amount',
  campaign_start: 'Campaign Start',
  campaign_end: 'Campaign End',
  campaign_id: 'Campaign Id',
  campaign_success_metric: 'Campaign Success Metric',
  campaign_settings: 'Campaign Settings',
  campaign_targeting: 'Targeting',
  campaign_status: 'Campaign Status',
  creative_size: 'Creative Size',
  city: 'City',
  campaign_name: 'Campaign Name',
  campaign_type: 'Campaign Type',
  channel: 'Channel',
  clear: 'Clear',
  clearAll: 'Clear all',
  clicks: 'Clicks',
  click_view_through: 'Click-Through',
  company_name: 'Company Name',
  company_office: 'Company Office',
  country_name: 'Country Name',
  connection_type: 'Connection Type',
  connection_type_targeting: 'Connection',
  connection_type_all: 'All',
  connection_type_wifi_only: 'Wi-Fi Only',
  conversion: 'Conversion',
  cost: 'Cost',
  cost_amount: 'Cost Amount',
  cost_currency: 'Cost Currency',
  country: 'Country',
  countries: 'Countries',
  dma_codes: 'DMA',
  dma_codes_hint: 'Designated Market Area, a geographic area that represents a specific television market.',
  country_code: 'Country',
  countryCode: 'Country',
  cost_per_action: 'Cost Per Action',
  cost_per_install: 'Cost Per Install',
  cost_per_mile: 'Cost Per Mile',
  cost_per_click: 'Cost Per Click',
  cost_per_x_help: 'This value is used by the YouAppi DSP RT bidder to optimize our bids, to make sure the final conversion will be equal or cheaper than this value. This value is NOT the final price per conversion, but rather a "Goal" for our bidder to aim for. Please note: Changes to this value may take up to one hour to take place and affect the bidding strategy.',
  creative_id: 'Creative Id',
  creative_type: 'Creative Type',
  creative_dimensions: 'Creative Dimensions',
  cta_text: 'Call to Action Text',
  ctv: 'CTV',
  ctv_username: 'Username',
  ctv_password: 'Password',
  dataSource: 'Data Source',
  dataSources: 'Data Sources',
  day_part: 'Day Part',
  day_part_assigned: '(Assigned)',
  day_of_week: 'Day of Week',
  week_of_year: 'Week of Year',
  description: 'Description',
  device: 'Device',
  device_type: 'Device Type',
  device_types: 'Device Types',
  device_id_type_targeting: 'User Device ID',
  device_os: 'Device OS',
  desktop_URL: 'Desktop URL',
  domain: 'Domain',
  segment_traffic: 'Segment Traffic',
  segment_traffic_help: 'The traffic that is being targeted by this segment.',
  segment_name: 'Segment',
  traffic_type: 'Traffic Type',
  traffic_type_all: 'All',
  traffic_type_with_id: 'Device ID',
  traffic_type_without_id: 'No Device ID',
  traffic_type_idfa: 'IDFA',
  traffic_type_idfv: 'IDFV',
  traffic_type_ip: 'TEST',
  traffic_type_default: 'All',
  game_domain_help: 'Used to fill the \'adomain\' field on bid responses. Must match the top level domain for the advertiser landing page and must be passed with only .TLD appended (e.g. domain.com or domain.de, without HTTP or WWW). In the case of app store destinations, the adomain should represent the app’s website and not the app store URL (e.g. for Awesome App, it should be awesomeapp.com). In the case of apps that do not have a registered domain, please use [App Name].com (e.g. appname.com).',
  mfa_help: 'MFA is enabled at login',
  ercr: 'CR',
  ios_URL: 'iOS Click URL',
  android_URL: 'Android Click URL',
  android_deep_link: 'Android Deep Link',
  ios_deep_link: 'IOS Deep Link',
  deep_link_URL: 'Deep link URL',
  email: 'Email',
  approve_user: 'Approve',
  approve_user_help: 'Change user status from pending approval to active',
  end_date: 'End date',
  engagement: 'Conversion',
  engagement_rate: 'Conversion Rate',
  event: 'Event',
  expenses_threshold: 'Expenses Threshold',
  external_id: 'External Id',
  gdpr: 'GDPR',
  gdpr_api_key: 'API Key',
  gdpr_email: 'Contact Email',
  genres: 'Genres',
  fees: 'Fees',
  first_name: 'First Name',
  firstPartyData: '1st Party Data',
  filter: 'Filter',
  filters: 'Filters',
  frequency_caps: 'Frequency Capping',
  frequency_cap_click_rule1: 'Click rule 1',
  frequency_cap_click_rule2: 'Click rule 2',
  frequency_cap_click_rule_help: 'Set the time after the click without impressions',
  frequency_cap_impression_rule1: 'Impression rule1',
  frequency_cap_impression_rule2: 'Impression rule2',
  frequency_cap_impression_rule_help: 'Set number of impressions to present to the user in a set time window',
  gaming_bundle: 'Gaming Bundle',
  hour_of_day: 'Hour of Day',
  iab_categories: 'Advertising Cateogry',
  id: 'Id',
  impressions: 'Impressions',
  impressions_view_through: 'View-Through',
  impression_attribution_percentage: 'Impr. Based Attr. (%)',
  impression_attribution_percentage_help: 'The precentage of view-through leads to be attributed to YouAppi DSP',
  inactive: "Inactive",
  language: 'Language',
  loadSavedAudience: 'Load Saved Audience',
  last_name: 'Last Name',
  lastModifiedAt: 'Last modified at',
  mfa: 'MFA Enabled',
  reset_mfa: 'Reset MFA',
  reset_selection: 'Reset Selection',
  monthly: 'Monthly',
  monthly_budget_amount: 'Monthly Budget',
  name: 'Name',
  variation_priority: 'Priority',
  variation_priority_hint: 'Enable to give this variation higher delivery priority',
  number_of_buyers: 'Number of buyers',
  number_of_products: 'Products Number',
  number_of_products_placeholder: '# Products',
  nth_impression: 'Nth Impression',
  max_bid_price: 'Max Bid Price',
  mfa_code: 'MFA Code',
  on_hold: 'On Hold',
  os: 'OS',
  lookalike_bundles: 'Look Alike Bundles',
  os_all: 'All',
  override_game_developer_name: 'App Developer Name',
  affle_billing_entity: 'Affle Billing Entity',
  advertiser_legal_entity_and_country: 'Advertiser Legal Entity and Country',
  operation_manager: 'Operation Manager',
  csm: 'CSM',
  optimization_funnel: 'Optimization Funnel',
  password: 'Password',
  password_confirmation: 'Password confirmation',
  platform: 'Platform',
  previousPeriod: 'Previous Period',
  pricing: 'Pricing',
  private_marketplace: 'Private Marketplace',
  autopilot_launcher: 'Autopilot Launcher',
  quality_fee: 'Quality Fee',
  quality_fee_help: 'Quality Fee (%)',
  rating: 'Rating',
  role: 'Role',
  roles: 'Roles',
  send_emails: 'Receive System Emails',
  verify_authorized_seller: 'Verify Authorized Seller',
  appsflyer_in_cost_api: 'AppsFlyer InCost API',
  mdsp: 'mDSP Client',
  show_payment_amounts: 'Show Payment Amounts',
  second_auction_bid: 'Second Auction Bid',
  secondPartyData: '2nd Party Data',
  spc_cpi: 'SP Campaign CPI',
  mmp: 'MMP',
  ssp: 'SSP',
  ssp_channels: 'SSP Channels',
  ssp_margin: 'SSP Margin',
  state: 'State',
  strategy: 'Strategy',
  street_address: 'Street Address',
  store_extended_cohort_dimensions: 'Store Extended Cohort Dimensions',
  traffic_source: 'Traffic Source',
  title: 'Title',
  creative_name: 'Creative Name',
  creative_name_help: 'Name of Creative. If no name is given it will be updated automatically from uploaded banner name.',
  creative_products_help: 'Set number of products from 1 to 10.',
  user_group: 'User Group',
  vat: 'VAT #',
  website: 'Website',
  zipcode: 'Zipcode',
  allow_retarget_after_days: 'Retarget Again After',
  allow_retarget_after_days_help: 'Configures after how many days a previously engaged user can be retargeted and engaged again on this campaign',
  auto_goals_optimization: 'Auto Optimization',
  run_every: 'Run every',
  days_word: 'days',
  optimization_method: 'Optimization Method',
  media_cost: "Daily Media Cost",
  media_cost_help: "Automatically cap the campaign when total daily media cost is reached.",
  lookback_window: "Attribution Window",
  click_lookback_window: "Click",
  click_lookback_window_help: "Configures the amount of days for click attribution window from 0 to 38 (Leave empty for system default)",
  impression_lookback_window: "Impression",
  impression_lookback_window_help: "Configures the amount of days for impression attribution window from 0 to 31 (Leave empty for system default)",
  lookback_app_open_window: "App Open Attr. Window",
  click_lookback_window_app_open: "Click",
  click_lookback_window_app_open_help: "Configures the value for click app open attribution window",
  click_lookback_window_app_open_timeframe: "Timeframe",
  click_lookback_window_app_open_timeframe_value: "Value",
  impression_lookback_window_app_open: "Impression",
  impression_lookback_window_app_open_help: "Configures the value for impression app open attribution window",
  impression_lookback_window_app_open_timeframe: "Timeframe",
  impression_lookback_window_app_open_timeframe_value: "Value",
  upload_tree_data: "Upload Tree Data",
  upload_tree_data_help: "Loading tree data to the campaign",
  upload_tree_data_of_game_id: "Select Game",
  upload_tree_data_of_campaign_id: "Select Campaign",
  tree_data_type: "Tree Data Type",
  tree_data_type_help: "Chose data type to feed into a tree",
  es_matched_users: "ES matched users",
  tl_matched_users: "TL matched users",

  // dimensions
  deviceIdKnown: 'Known',
  deviceIdUnknown: 'Unknown',
  deviceIdIDFA: 'IDFA',
  deviceIdIDFV: 'IDFV',
  deviceIdIP: 'IP',
  sspsSource: 'SSPs',
  acquisitionSource: 'Acquisition Source',
  facebookId: 'Facebook',
  google: 'Google',
  twitterId: 'Twitter',
  organic: 'Organic',
  regDate: 'Registration date',
  paidAmount: 'Payment Amount',
  payments: 'Payment Event',
  paymentType: 'Payment Type',
  session: 'Session',
  paying: 'Paying',
  progress: 'Progress',

  //dimension values
  not_targeted: 'Not Targeted',
  acquisitionSourceZeroKey: 'Without ReAppi',
  acquisitionSourceSimplaexKey: 'ReAppi Only',

  //cohorts

  cohorts_retention_help: 'The number of users in the cohort who returned in the Nth bucket, divided by the total number of users in the cohort',
  cohorts_appLevelUUReportWithNonUniqueCampaignMessage: 'Note - at least one of the campaigns was set to use Non-Unique User measurement',
  cohorts_appLevelRawReportWithNonUniqueCampaignMessage: 'Note - at least one of the campaigns was set to use Unique User measurement',
  cohorts_roi_help: 'Sum Amount of revenue gained by users in the cohort by the Nth bucket, divided by the total cost of users in the cohort',
  cohorts_dau_help: 'The absolute number of users in the cohort who returned in the Nth bucket',
  cohorts_payers_rate_help: 'The number of users who Paid in the cohort who returned in the Nth day divided by the total number of users in the cohort',
  cohorts_revenue_help: 'Sum Amount of revenue gained by users in the cohort by the Nth bucket',
  cohorts_ad_revenue_help: 'Sum Amount of ad revenue gained by users in the cohort by the Nth bucket',

  // analytics
  $analytics: {
    avg: 'AVG.',
    sum: 'Total',
    game: {
      new_players: {
        label: 'New Users',
        help: 'Daily New Users',
      },
      dau: {
        label: 'DAU',
        help: 'Daily Active Users'
      },
      arp_dau: {
        label: 'ARPDAU',
        help: 'Average Revenue Per Daily Active User',
      },
      arp_pu: {
        label: 'ARPPU',
        help: 'Average Revenue Per Paying User',
      },
      sessions_to_dau: {
        label: 'Sessions/DAU',
        help: 'Count of all sessions for a unique user on a given day',
      },
      sessions: {
        label: 'Sessions',
        help: 'Number of sessions your users run per day',
      },
      conversion_rate: {
        label: 'Payment Rate',
        help: 'Percentage of users that have made a purchase out of the total number of users on a given day',
      },
      'dau/mau': {
        label: 'DAU/MAU',
        help: 'Percentage of MAU (count of all unique user IDs with a session start in a given month) that are active every day',
      },
      transactions: {
        label: 'Transactions',
        help: 'Transactions',
      },
      revenue: {
        label: 'Revenue',
        help: 'Revenue',
      },
      'dpu': {
        label: 'DPU',
        help: 'Daily Paying Users',
      },
      conversions: {
        label: 'Conversion Events',
        help: 'The share of YouAppi in Conversion Events',
      },
      share_trend: {
        label: 'Share Trend',
        help: 'Share Trend',
      },
      daily_app_conversion: {
        label: '',
        help: ''
      },
      installsConversionEvents: {
        label: '30 days trend – Installs-to-Events - App',
        help: 'Entire App, and ReAppi and Not-ReAppi shares in the Installs-to-events - App',
        series: {
          daily_app_conversion: {
            label: 'Daily app Conversion',
            help: 'Entire App, and ReAppi and Not-ReAppi shares in the Installs-to-events - App'
          }
        }
      },
    },
    segment: {
      joining: {
        label: 'New',
        help: 'New'
      },
      leaving: {
        label: 'Leaving',
        help: 'Leaving'
      },
      size: {
        label: 'Segment Size',
        help: 'Segment Size',
        series: {
          joining: {
            label: 'New',
            help: 'New'
          },
          leaving: {
            label: 'Leaving',
            help: 'Leaving'
          },
          size: {
            label: 'Segment Size',
            help: 'Segment Size'
          }
        }
      },
      paying_users: {
        title: 'Users Life time Value',
        label: 'Paying Users',
        help: 'Paying Users',
      },
      payments: {
        label: 'Payments',
        help: 'Payments',
        series: {
          paying_users: {
            label: 'Paying Users',
            help: 'Paying Users',
          },
          payments: {
            label: 'Payments',
            help: 'Payments'
          },
          revenue: {
            label: 'Revenue',
            help: 'Revenue'
          }
        }
      },
      revenue: {
        label: 'Revenue',
        help: 'Revenue'
      },
      revenueLeads: {
        label: 'Revenue & Leads',
        help: 'Amount of users sold (leads) compared to revenue gained',
        series: {
          seller_share: {
            label: 'Revenue',
            help: 'Revenue gained'
          },
          leads: {
            label: 'Leads',
            help: 'Amount of users sold'
          },
          erpi: {
            label: 'eRPI',
            help: 'The effective revenue per sold user'
          }
        }
      },
      performance: {
        label: 'Performance',
        help: 'Amount of impressions shown to your users, compared to amount of clicks clicked',
        series: {
          clicks: {
            label: 'Clicks',
            help: 'Clicks'
          },
          impressions: {
            label: 'Impressions',
            help: 'Impressions'
          },
          ctr: {
            label: 'CTR',
            help: 'CTR'
          }
        }
      },
      topCountries: {
        label: 'Countries',
        help: 'Top Countries',
      },
      topPlatforms: {
        label: 'Platforms',
        help: 'Top Platforms',
      },
      topAcquisitionSources: {
        label: 'Acquisition Sources',
        help: 'Top Acquisition Sources',
      },
      knownIds: {
        label: 'Known IDs',
        help: 'Known IDs',
      },
      rpi: {
        label: 'RPI',
        help: "RPI - Revenue Per Install. This is the estimated value of users from this segment. The value is based on users' in-app behavior like activity, payment, GEO and devices. Please note that out of this value the YouAppi DSP share will be taken when selling a user, based on agreed fees.",
      }
    },
    campaign: {
      engagement: {
        label: 'Targeted & Converted',
        help: 'Targeted & Converted',
        series: {
          daily_targeted_players: {
            label: 'Daily Targeted Users',
            help: 'Daily Targeted Users'
          },
          targeted_players: {
            label: 'Targeted Users',
            help: 'Targeted Users'
          },
          engaged_players: {
            label: 'Conversions',
            help: 'Conversions'
          },
          engagement_rate: {
            label: 'Engagement Rate',
            help: 'Engagement Rate'
          },
          conversion_rate: {
            label: 'Conversion Rate',
            help: 'Conversion Rate'
          },
          app_open: {
            label: 'App Open',
            help: 'Sum of App Open (Re-Engagement) '
          },
          app_open_rate: {
            label: 'App Open Rate',
            help: 'Sum of App Open (Re-Engagement) divided by the sum of Clicks'
          },
          installs: {
            label: 'Installs',
            help: 'Sum of Installs (User Acquisition) '
          },
          installs_rate: {
            label: 'Installs Rate',
            help: 'Sum of Installs (User Acquisition) divided by the sum of Clicks'
          }
        }
      },
      performance: {
        help: 'Campaign Performance',
        label: 'Campaign Performance',
        series: {
          clicks: {
            help: 'Clicks',
            label: 'Clicks'
          },
          impressions: {
            help: 'Impressions',
            label: 'Impressions'
          },
          ctr: {
            help: 'CTR',
            label: 'CTR'
          },
          leads: {
            label: 'Leads',
            help: 'Leads'
          }
        }
      },
      leads: {
        label: 'Leads',
        help: 'Leads'
      },
      cost: {
        label: 'Cost',
        help: 'Cost'
      },
      cpqi: {
        label: 'Cost',
        help: 'Cost'
      },
      ecpqi: {
        label: 'eCPQI',
        help: 'eCPQI'
      },
      ecpc: {
        label: 'eCPC',
        help: 'The AVG amount paid for a user who clicked'
      },
      ecpm: {
        label: 'eCPM',
        help: 'The AVG amount paid for 1000 impression'
      },
      ecpa: {
        label: 'eCPA',
        help: 'The AVG amount paid for an Converted User'
      },
      ecpi: {
        label: 'eCPI',
        help: 'The AVG amount paid for a user who installed'
      },
      ecpo: {
        label: 'eCPO',
        help: 'The AVG amount paid for a user who opened app'
      },
      ecpe: {
        label: 'eCPA',
        help: 'The AVG amount paid for an Converted User'
      },
      topChannels: {
        label: 'Top Channels',
        help: 'Top Channels',
        series: {
          conversion_rate: {
            label: 'Conversion Rate',
            help: 'Percentage of users that have made a purchase out of the total number of users on a given day',
          },
          targeted_players: {
            label: 'Targeted',
            help: 'Amount of unique users that had impression from a channel'
          },
          engaged_players: {
            label: 'Conversions',
            help: 'Amount of unique converted users that had impression from a channel'
          },
          clicks: {
            label: 'Clicks',
            help: 'Amount of clicks that came from a channel'
          },
          impressions: {
            label: 'Impressions',
            help: 'Amount of impressions (not unique) that came from a channel'
          },
          leads: {
            label: 'Leads',
            help: 'Leads'
          },
          ctr: {
            label: 'CTR',
            help: 'The rate of people who clicked on an ad out of total impressions of a channel'
          },
          cr: {
            label: 'CR',
            help: ''
          },
          cost: {
            label: 'Cost',
            help: 'The sum of all winning bids of this channel'
          },
          ecpc: {
            label: 'eCPC',
            help: 'The AVG amount paid for a user who clicked'
          },
          ecpa: {
            label: 'eCPA',
            help: 'The AVG amount paid for an Converted User'
          },
          ecpe: {
            label: 'eCPA',
            help: 'The AVG amount paid for an Converted User'
          },
          ecpm: {
            label: 'eCPM',
            help: 'The AVG amount paid for 1000 impression'
          },
          ecpi: {
            label: 'eCPI',
            help: 'The AVG amount paid for a user who installed'
          },
          ecpo: {
            label: 'eCPO',
            help: 'The AVG amount paid for a user who opened app'
          },
          cpqi: {
            label: 'CPQI',
            help: 'Cost Per Quality Install'
          },
          ecpqi: {
            label: 'eCPQI',
            help: ''
          },
          app_open: {
            label: 'App Open',
            help: 'Sum of App Open (Re-Engagement) '
          },
          app_open_rate: {
            label: 'App Open Rate',
            help: 'Sum of App Open (Re-Engagement) divided by the sum of Clicks'
          },
          installs: {
            label: 'Installs',
            help: 'Sum of Installs (User Acquisition) '
          },
          installs_rate: {
            label: 'Installs Rate',
            help: 'Sum of Installs (User Acquisition) divided by the sum of Clicks'
          }
        }
      },
      topCreativeTypes: {
        label: 'Top Creative Types',
        help: 'Top Creative Types',
        series: {
          conversion_rate: {
            label: 'Conversion Rate',
            help: 'Percentage of users that have made a purchase out of the total number of users on a given day',
          },
          targeted_players: {
            label: 'Targeted',
            help: 'Amount of unique users that had impression from creative type'
          },
          engaged_players: {
            label: 'Conversions',
            help: 'Amount of unique converted users that had impression from creative type'
          },
          clicks: {
            label: 'Clicks',
            help: 'Amount of clicks that came from creative type'
          },
          impressions: {
            label: 'Impressions',
            help: 'Amount of impressions (not unique) that came from creative type'
          },
          leads: {
            label: 'Leads',
            help: 'Leads'
          },
          ctr: {
            label: 'CTR',
            help: 'The rate of people who clicked on an ad out of total impressions of a creative type'
          },
          cr: {
            label: 'CR',
            help: ''
          },
          cost: {
            label: 'Cost',
            help: 'The sum of all winning bids of this creative type'
          },
          ecpc: {
            label: 'eCPC',
            help: 'The AVG amount paid for a user who clicked'
          },
          ecpa: {
            label: 'eCPA',
            help: 'The AVG amount paid for an Converted User'
          },
          ecpe: {
            label: 'eCPA',
            help: 'The AVG amount paid for an Converted User'
          },
          ecpm: {
            label: 'eCPM',
            help: 'The AVG amount paid for 1000 impression'
          },
          ecpi: {
            label: 'eCPI',
            help: 'The AVG amount paid for a user who installed'
          },
          ecpo: {
            label: 'eCPO',
            help: 'The AVG amount paid for a user who opened app'
          },
          cpqi: {
            label: 'CPQI',
            help: 'Cost Per Quality Install'
          },
          ecpqi: {
            label: 'eCPQI',
            help: ''
          },
          app_open: {
            label: 'App Open',
            help: 'Sum of App Open (Re-Engagement) '
          },
          app_open_rate: {
            label: 'App Open Rate',
            help: 'Sum of App Open (Re-Engagement) divided by the sum of Clicks'
          },
          installs: {
            label: 'Installs',
            help: 'Sum of Installs (User Acquisition) '
          },
          installs_rate: {
            label: 'Installs Rate',
            help: 'Sum of Installs (User Acquisition) divided by the sum of Clicks'
          }
        }
      },
      creativeSizePerformance: {
        label: 'Creative Size Performance',
        help: 'Creative Size Performance',
        series: {
          targeted_players: {
            label: 'Targeted',
            help: 'Amount of unique users that had impression from a channel'
          },
          engaged_players: {
            label: 'Conversions',
            help: 'Amount of unique converted users that had impression from a channel'
          },
          clicks: {
            label: 'Clicks',
            help: 'Amount of clicks that came from a channel'
          },
          impressions: {
            label: 'Impressions',
            help: 'Amount of impressions (not unique) that came from a channel'
          },
          ctr: {
            label: 'CTR',
            help: 'The rate of people who clicked on an ad out of total impressions of a channel'
          },
          cr: {
            label: 'CR',
            help: ''
          },
          cost: {
            label: 'Cost',
            help: 'The sum of all winning bids of this channel'
          },
          ecpc: {
            label: 'eCPC',
            help: 'The AVG amount paid for a user who clicked'
          },
          ecpa: {
            label: 'eCPA',
            help: 'The AVG amount paid for an Converted User'
          },
          ecpm: {
            label: 'eCPM',
            help: 'The AVG amount paid for 1000 impression'
          },
          ecpi: {
            label: 'eCPI',
            help: 'The AVG amount paid for a user who installed'
          },
          ecpo: {
            label: 'eCPO',
            help: 'The AVG amount paid for a user who opened app'
          },
          cpqi: {
            label: 'CPQI',
            help: 'Cost Per Quality Install'
          },
          ecpqi: {
            label: 'eCPQI',
            help: ''
          },
          leads: {
            label: 'Leads',
            help: ''
          },
          app_open: {
            label: 'App Open',
            help: 'Sum of App Open (Re-Engagement) '
          },
          app_open_rate: {
            label: 'App Open Rate',
            help: 'Sum of App Open (Re-Engagement) divided by the sum of Clicks'
          },
          installs: {
            label: 'Installs',
            help: 'Sum of Installs (User Acquisition) '
          },
          installs_rate: {
            label: 'Installs Rate',
            help: 'Sum of Installs (User Acquisition) divided by the sum of Clicks'
          }
        }
      },
      creativeVariationPerformance: {
        label: 'Creative Variation Performance',
        help: 'Creative Variation Performance',
        series: {
          targeted_players: {
            label: 'Targeted',
            help: ''
          },
          engaged_players: {
            label: 'Converted',
            help: ''
          },
          clicks: {
            label: 'Clicks',
            help: '-'
          },
          impressions: {
            label: 'Impressions',
            help: ''
          },
          ctr: {
            label: 'CTR',
            help: ''
          },
          cr: {
            label: 'CR',
            help: ''
          },
          cost: {
            label: 'Cost',
            help: ''
          },
          ecpc: {
            label: 'eCPC',
            help: ''
          },
          ecpa: {
            label: 'eCPA',
            help: 'The AVG amount paid for an Converted User'
          },
          ecpm: {
            label: 'eCPM',
            help: ''
          },
          ecpi: {
            label: 'eCPI',
            help: 'The AVG amount paid for a user who installed'
          },
          ecpo: {
            label: 'eCPO',
            help: 'The AVG amount paid for a user who opened app'
          },
          app_open: {
            label: 'App Open',
            help: 'Sum of App Open (Re-Engagement) '
          },
          app_open_rate: {
            label: 'App Open Rate',
            help: 'Sum of App Open (Re-Engagement) divided by the sum of Clicks'
          },
          installs: {
            label: 'Installs',
            help: 'Sum of Installs (User Acquisition) '
          },
          installs_rate: {
            label: 'Installs Rate',
            help: 'Sum of Installs (User Acquisition) divided by the sum of Clicks'
          }
        }
      },
      creativeId: {
        label: 'Creative ID',
        help: 'Creative ID',
        series: {
          conversion_rate: {
            label: 'Conversion Rate',
            help: 'Percentage of users that have made a purchase out of the total number of users on a given day',
          },
          targeted_players: {
            label: 'Targeted',
            help: ''
          },
          engaged_players: {
            label: 'Conversions',
            help: ''
          },
          clicks: {
            label: 'Clicks',
            help: ''
          },
          impressions: {
            label: 'Impressions',
            help: ''
          },
          leads: {
            label: 'Leads',
            help: 'Leads'
          },
          ctr: {
            label: 'CTR',
            help: ''
          },
          cr: {
            label: 'CR',
            help: ''
          },
          cost: {
            label: 'Cost',
            help: ''
          },
          ecpc: {
            label: 'eCPC',
            help: ''
          },
          ecpa: {
            label: 'eCPA',
            help: ''
          },
          ecpm: {
            label: 'eCPM',
            help: ''
          },
          ecpi: {
            label: 'eCPI',
            help: 'The AVG amount paid for a user who installed'
          },
          ecpo: {
            label: 'eCPO',
            help: 'The AVG amount paid for a user who opened app'
          },
          cpqi: {
            label: 'CPQI',
            help: 'Cost Per Quality Install'
          },
          ecpqi: {
            label: 'eCPQI',
            help: ''
          },
          app_open: {
            label: 'App Open',
            help: ''
          },
          app_open_rate: {
            label: 'App Open Rate',
            help: ''
          }
        }
      },
      creativeDimension: {
        label: 'Creative Dimension',
        help: 'Creative Dimension',
        series: {
          conversion_rate: {
            label: 'Conversion Rate',
            help: 'Percentage of users that have made a purchase out of the total number of users on a given day',
          },
          cpqi: {
            label: 'CPQI',
            help: 'Cost Per Quality Install'
          },
          ecpqi: {
            label: 'eCPQI',
            help: ''
          },
          targeted_players: {
            label: 'Targeted',
            help: ''
          },
          engaged_players: {
            label: 'Conversions',
            help: ''
          },
          clicks: {
            label: 'Clicks',
            help: ''
          },
          impressions: {
            label: 'Impressions',
            help: ''
          },
          leads: {
            label: 'Leads',
            help: 'Leads'
          },
          ctr: {
            label: 'CTR',
            help: ''
          },
          cr: {
            label: 'CR',
            help: ''
          },
          cost: {
            label: 'Cost',
            help: ''
          },
          ecpc: {
            label: 'eCPC',
            help: ''
          },
          ecpa: {
            label: 'eCPA',
            help: ''
          },
          ecpm: {
            label: 'eCPM',
            help: ''
          },
          ecpi: {
            label: 'eCPI',
            help: 'The AVG amount paid for a user who installed'
          },
          ecpo: {
            label: 'eCPO',
            help: 'The AVG amount paid for a user who opened app'
          },
          app_open: {
            label: 'App Open',
            help: ''
          },
          app_open_rate: {
            label: 'App Open Rate',
            help: ''
          },
          installs: {
            label: 'Installs',
            help: ''
          },
          installs_rate: {
            label: 'Installs Rate',
            help: ''
          }
        }
      },
      topCountries: {
        label: 'Top Countries',
        help: 'Top Countries',
        series: {
          targeted_players: {
            label: 'Targeted',
            help: 'Amount of unique users that had impression from a country'
          },
          engaged_players: {
            label: 'Conversions',
            help: 'Amount of unique Conversions that had impression from a country'
          },
          clicks: {
            label: 'Clicks',
            help: 'Amount of clicks that came from a country'
          },
          conversion_rate: {
            label: 'Conversion rate',
            help: 'Percentage of users that have made a purchase out of the total number of users on a given day'
          },
          impressions: {
            label: 'Impressions',
            help: 'Amount of impressions (not unique) that came from a country'
          },
          ctr: {
            label: 'CTR',
            help: 'The rate of people who clicked on an ad out of total impressions of a country'
          },
          cr: {
            label: 'CR',
            help: ''
          },
          cost: {
            label: 'Cost',
            help: 'The sum of all winning bids of this country'
          },
          ecpc: {
            label: 'eCPC',
            help: 'The AVG amount paid for a user who clicked'
          },
          ecpa: {
            label: 'eCPA',
            help: 'The AVG amount paid for an Converted User'
          },
          ecpi: {
            label: 'eCPI',
            help: 'The AVG amount paid for a user who installed'
          },
          ecpo: {
            label: 'eCPO',
            help: 'The AVG amount paid for a user who opened app'
          },
          ecpe: {
            label: 'eCPA',
            help: 'The AVG amount paid for an Converted User'
          },
          ecpm: {
            label: 'eCPM',
            help: 'The AVG amount paid for 1000 impression'
          },
          cpqi: {
            label: 'CPQI',
            help: 'Cost Per Quality Install'
          },
          ecpqi: {
            label: 'eCPQI',
            help: ''
          },
          leads: {
            label: 'Leads',
            help: ''
          },
          app_open: {
            label: 'App Open',
            help: 'Sum of App Open (Re-Engagement) '
          },
          app_open_rate: {
            label: 'App Open Rate',
            help: 'Sum of App Open (Re-Engagement) divided by the sum of Clicks'
          },
          installs: {
            label: 'Installs',
            help: 'Sum of Installs (User Acquisition) '
          },
          installs_rate: {
            label: 'Installs Rate',
            help: 'Sum of Installs (User Acquisition) divided by the sum of Clicks'
          }
        }
      },
      topPlatforms: {
        label: 'Top Platforms',
        help: 'Top Platforms',
        series: {
          targeted_players: {
            label: 'Targeted',
            help: 'Amount of unique users that had impression from a channel'
          },
          engaged_players: {
            label: 'Conversions',
            help: 'Amount of unique Conversions that had impression from a channel'
          },
          clicks: {
            label: 'Clicks',
            help: 'Amount of clicks that came from a channel'
          },
          conversion_rate: {
            label: 'Conversion rate',
            help: 'Percentage of users that have made a purchase out of the total number of users on a given day'
          },
          impressions: {
            label: 'Impressions',
            help: 'Amount of impressions (not unique) that came from a channel'
          },
          ctr: {
            label: 'CTR',
            help: 'The rate of people who clicked on an ad out of total impressions of a channel'
          },
          cr: {
            label: 'CR',
            help: ''
          },
          cost: {
            label: 'Cost',
            help: 'The sum of all winning bids of this channel'
          },
          ecpc: {
            label: 'eCPC',
            help: 'The AVG amount paid for a user who clicked'
          },
          ecpa: {
            label: 'eCPA',
            help: 'The AVG amount paid for an Converted User'
          },
          ecpe: {
            label: 'eCPA',
            help: 'The AVG amount paid for an Converted User'
          },
          ecpm: {
            label: 'eCPM',
            help: 'The AVG amount paid for 1000 impression'
          },
          ecpi: {
            label: 'eCPI',
            help: 'The AVG amount paid for a user who installed'
          },
          ecpo: {
            label: 'eCPO',
            help: 'The AVG amount paid for a user who opened app'
          },
          cpqi: {
            label: 'CPQI',
            help: 'Cost Per Quality Install'
          },
          ecpqi: {
            label: 'eCPQI',
            help: ''
          },
          leads: {
            label: 'Leads',
            help: ''
          },
          app_open: {
            label: 'App Open',
            help: 'Sum of App Open (Re-Engagement) '
          },
          app_open_rate: {
            label: 'App Open Rate',
            help: 'Sum of App Open (Re-Engagement) divided by the sum of Clicks'
          },
          installs: {
            label: 'Installs',
            help: 'Sum of Installs (User Acquisition) '
          },
          installs_rate: {
            label: 'Installs Rate',
            help: 'Sum of Installs (User Acquisition) divided by the sum of Clicks'
          }
        }
      },
      inGameEvents: {
        label: 'In-App Events',
        help: 'In-App Events',
        series: {
          paidAmount_1_avg: {
            label: 'Paid amount in the last day',
            help: 'Paid amount in the last day'
          },
          paidAmount_3_avg: {
            label: 'Paid amount in the last 3 days',
            help: 'Paid amount in the last 3 days'
          },
          paidAmount_7_avg: {
            label: 'Paid amount in the last 7 days',
            help: 'Paid amount in the last 7 days'
          },
          paidAmount_14_avg: {
            label: 'Paid amount in the last 14 days',
            help: 'Paid amount in the last 14 days'
          },
          paidAmount_30_avg: {
            label: 'Paid amount in the last 30 days',
            help: 'Paid amount in the last 30 days'
          },
          payments_1_avg: {
            label: 'Payments in the last day',
            help: 'Payments in the last day'
          },
          payments_3_avg: {
            label: 'Payments in the last 3 days',
            help: 'Payments in the last 3 days'
          },
          payments_7_avg: {
            label: 'Payments in the last 7 days',
            help: 'Payments in the last 7 days'
          },
          payments_14_avg: {
            label: 'Payments in the last 14 days',
            help: 'Payments in the last 14 days'
          },
          payments_30_avg: {
            label: 'Payments in the last 30 days',
            help: 'Payments in the last 30 days'
          },
          sessions_1_avg: {
            label: 'Sessions in the last day',
            help: 'Sessions in the last day'
          },
          sessions_3_avg: {
            label: 'Sessions in the last 3 days',
            help: 'Sessions in the last 3 days'
          },
          sessions_7_avg: {
            label: 'Sessions in the last 7 days',
            help: 'Sessions in the last 7 days'
          },
          sessions_14_avg: {
            label: 'Sessions in the last 14 days',
            help: 'Sessions in the last 14 days'
          },
          sessions_30_avg: {
            label: 'Sessions in the last 30 days',
            help: 'Sessions in the last 30 days'
          }
        }
      },
      publisher: {
        label: 'Publisher',
        help: 'Publisher',
        series: {
          cpqi: {
            label: 'CPQI',
            help: 'Cost Per Quality Install'
          },
          ecpqi: {
            label: 'eCPQI',
            help: ''
          },
          leads: {
            label: 'Leads',
            help: ''
          },
          conversion_rate: {
            label: 'Conversion rate',
            help: 'Percentage of users that have made a purchase out of the total number of users on a given day'
          },
          targeted_players: {
            label: 'Targeted',
            help: 'Amount of unique users that had impression from a publisher'
          },
          engaged_players: {
            label: 'Conversions',
            help: 'Amount of unique Conversions that had impression from a publisher'
          },
          clicks: {
            label: 'Clicks',
            help: 'Amount of clicks that came from a publisher'
          },
          impressions: {
            label: 'Impressions',
            help: 'Amount of impressions (not unique) that came from a publisher'
          },
          ctr: {
            label: 'CTR',
            help: 'The rate of people who clicked on an ad out of total impressions of a publisher'
          },
          cr: {
            label: 'CR',
            help: ''
          },
          cost: {
            label: 'Cost',
            help: 'The sum of all winning bids of this publisher'
          },
          ecpc: {
            label: 'eCPC',
            help: 'The AVG amount paid for a user who clicked'
          },
          ecpa: {
            label: 'eCPA',
            help: 'The AVG amount paid for an Converted User'
          },
          ecpe: {
            label: 'eCPA',
            help: 'The AVG amount paid for an Converted User'
          },
          ecpm: {
            label: 'eCPM',
            help: 'The AVG amount paid for 1000 impression'
          },
          ecpi: {
            label: 'eCPI',
            help: 'The AVG amount paid for a user who installed'
          },
          ecpo: {
            label: 'eCPO',
            help: 'The AVG amount paid for a user who opened app'
          },
          installs: {
            label: 'Installs',
            help: 'Sum of Installs'
          },
          app_open: {
            label: 'App Open',
            help: 'Sum of App Open (Re-Engagement) '
          },
          app_open_rate: {
            label: 'App Open Rate',
            help: 'Sum of App Open (Re-Engagement) divided by the sum of Clicks'
          }
        }
      },
      ssp: {
        label: 'Ssp',
        help: 'Ssp',
        series: {
          cpqi: {
            label: 'CPQI',
            help: 'Cost Per Quality Install'
          },
          ecpqi: {
            label: 'eCPQI',
            help: ''
          },
          leads: {
            label: 'Leads',
            help: ''
          },
          conversion_rate: {
            label: 'Conversion rate',
            help: 'Percentage of users that have made a purchase out of the total number of users on a given day'
          },
          targeted_players: {
            label: 'Targeted',
            help: 'Amount of unique users that had impression from a publisher'
          },
          engaged_players: {
            label: 'Conversions',
            help: 'Amount of unique Conversions that had impression from a publisher'
          },
          clicks: {
            label: 'Clicks',
            help: 'Amount of clicks that came from a publisher'
          },
          impressions: {
            label: 'Impressions',
            help: 'Amount of impressions (not unique) that came from a publisher'
          },
          ctr: {
            label: 'CTR',
            help: 'The rate of people who clicked on an ad out of total impressions of a publisher'
          },
          cost: {
            label: 'Cost',
            help: 'The sum of all winning bids of this publisher'
          },
          ecpc: {
            label: 'eCPC',
            help: 'The AVG amount paid for a user who clicked'
          },
          ecpa: {
            label: 'eCPA',
            help: 'The AVG amount paid for an Converted User'
          },
          ecpe: {
            label: 'eCPA',
            help: 'The AVG amount paid for an Converted User'
          },
          ecpm: {
            label: 'eCPM',
            help: 'The AVG amount paid for 1000 impression'
          },
          app_open: {
            label: 'App Open',
            help: 'Sum of App Open (Re-Engagement) '
          },
          app_open_rate: {
            label: 'App Open Rate',
            help: 'Sum of App Open (Re-Engagement) divided by the sum of Clicks'
          }
        }
      },
    },
    audience: {
      genres: {
        label: 'Genres',
        help: 'List of Genres users from the Marketplace play.'
      },
      osDevices: {
        label: 'Device / OS',
        help: 'Breakdown of which OS and Device Types the users in the Marketplace use.'
      },
      paying: {
        label: 'Paying vs Not Paying',
        help: 'Percentage of users in the Marketplace that pay, VS. not paying.'
      },
      activity: {
        label: 'Activity level',
        help: 'Amount of days a users in the Marketplace played in an app.'
      },
      paid_amount: {
        label: 'Payment amount',
        help: 'The amount of payments users in the Marketplace paid in other apps.'
      },
      active_days: {
        label: 'Active days per month',
        help: 'Avg. number of days per month users played an app.'
      },
      cpqi: {
        label: 'CPQI',
        help: 'Cost Per Quality Install. This is the estimated cost of users in the Marketplace, calculated based on their quality.'
      },
      cpm: {
        label: 'Users per Quality Fee',
        help: 'Users per Quality Fee'
      }
    },
    engagement: {
      impressions: {
        label: 'Impressions',
        help: 'Conversion - Impressions'
      },
      clicks: {
        label: 'Clicks',
        help: 'Conversion - Clicks'
      },
      targeted_players: {
        label: 'Targeted users',
        help: 'Conversion - Targeted users'
      },
      engaged_players: {
        label: 'Conversions',
        help: 'Conversions'
      },
      engagement_rate: {
        label: 'Conversion rate',
        help: 'Conversion rate'
      },
      conversion_rate: {
        label: 'Conversion rate',
        help: 'Conversion rate'
      },
      cost: {
        label: 'Cost',
        help: 'Conversion - Cost'
      },
      revenue: {
        label: 'Revenue',
        help: 'Revenue',
        series: {
          cost: {
            label: 'Revenue',
            help: 'Revenue'
          }
        }
      },
      ctr: {
        label: 'CTR',
        help: 'Conversion - CTR'
      },
      ecpe: {
        label: 'eCPA',
        help: 'Conversion - eCPA'
      },
      app_open: {
        label: 'App Open',
        help: 'Sum of App Open (Re-Engagement) '
      },
      app_open_rate: {
        label: 'App Open Rate',
        help: 'Sum of App Open (Re-Engagement) divided by the sum of Clicks'
      },
      installs: {
        label: 'Installs',
        help: 'Sum of Installs (User Acquisition) '
      },
      installs_rate: {
        label: 'Installs Rate',
        help: 'Sum of Installs (User Acquisition) divided by the sum of Clicks'
      }
    },
    acquisition: {
      impressions: {
        label: 'Impressions',
        help: 'Acquisition - Impressions'
      },
      clicks: {
        label: 'Clicks',
        help: 'Acquisition - Clicks'
      },
      leads: {
        label: 'Leads',
        help: 'Acquisition - Leads'
      },
      conversion_rate: {
        label: 'Conversion rate',
        help: 'Acquisition - Conversion rate'
      },
      cpqi: {
        label: 'Cost',
        help: 'Acquisition - Cost'
      },
      ctr: {
        label: 'CTR',
        help: 'Conversion - CTR'
      },
      ecpqi: {
        label: 'eCPQI',
        help: 'Acquisition - eCPQI'
      },
      app_open: {
        label: 'App Open',
        help: 'Sum of App Open (Re-Engagement) '
      },
      app_open_rate: {
        label: 'App Open Rate',
        help: 'Sum of App Open (Re-Engagement) divided by the sum of Clicks'
      },
      installs: {
        label: 'Installs',
        help: 'Sum of Installs (User Acquisition) '
      },
      installs_rate: {
        label: 'Installs Rate',
        help: 'Sum of Installs (User Acquisition) divided by the sum of Clicks'
      }
    },
    selling: {
      impressions: {
        label: 'Impressions',
        help: 'Selling - Impressions'
      },
      clicks: {
        label: 'Clicks',
        help: 'Selling - Clicks'
      },
      leads: {
        label: 'Leads',
        help: 'Selling - Leads'
      },
      conversion_rate: {
        label: 'Conversion rate',
        help: 'Selling - Conversion rate'
      },
      seller_share: {
        label: 'Revenue',
        help: 'Selling - Revenue'
      },
      erpi: {
        label: 'eRPI',
        help: 'Selling - eRPI'
      },
      app_open: {
        label: 'App Open',
        help: 'Sum of App Open (Re-Engagement) '
      },
      app_open_rate: {
        label: 'App Open Rate',
        help: 'Sum of App Open (Re-Engagement) divided by the sum of Clicks'
      }
    },
    explore: {
      active_days: {
        label: 'Active Days',
        help: 'Active Days'
      },
      age: {
        label: 'Age',
        help: 'Age',
        series: {
          age: {
            label: 'Age',
            help: 'Age'
          }
        }
      },
      apps: {
        label: 'Apps',
        help: 'Apps'
      },
      conversion_rate: {
        label: 'Conversion Rate',
        help: 'Conversion Rate'
      },
      countries: {
        label: 'Countries',
        help: 'Countries'
      },
      gender: {
        label: 'Gender',
        help: 'Gender'
      },
      genre: {
        label: 'Genre',
        help: 'Genre'
      },
      income: {
        label: 'Income',
        help: 'Income'
      },
      os: {
        label: 'OS',
        help: 'OS'
      },
      played_genres: {
        label: 'Played Genres',
        help: 'Played Genres'
      },
      paying: {
        label: 'Paying',
        help: 'Paying'
      },
      revenue: {
        label: 'Revenue',
        help: 'Revenue'
      },
      sessions_per_day: {
        label: 'Sessions per Day',
        help: 'Sessions per Day'
      },
      transaction: {
        label: 'Transaction',
        help: 'Transaction'
      }
    },
    revenue: {
      revenue: {
        label: 'Total Revenue',
        help: 'Revenue',
        series: {
          cost: {
            label: 'Revenue',
            help: 'The total revenue for the selected period'
          }
        }
      },

      topCountries: {
        label: 'Top Countries',
        help: 'Top Countries',
        series: {
          cost: {
            label: 'Revenue',
            help: 'Top countries revenue for the selected period'
          },
        }
      },
      topPlatforms: {
        label: 'Top Platforms',
        help: 'Top Platforms',
        series: {
          cost: {
            label: 'Revenue',
            help: 'Top platforms revenue for the selected period'
          },
        }
      },
      topChannels: {
        label: 'Top Channels',
        help: 'Top Channels',
        series: {
          cost: {
            label: 'Revenue',
            help: 'Top Channels revenue for the selected period'
          },
        }
      },
      topCreativeTypes: {
        label: 'Top Creative Types',
        help: 'Top Creative Types',
        series: {
          cost: {
            label: 'Revenue',
            help: 'Top Creative Types revenue for the selected period'
          },
        }
      },
      topGames: {
        label: 'Top Games',
        help: 'Top Games',
        series: {
          cost: {
            label: 'Revenue',
            help: 'Top games revenue for the selected period'
          },
        }
      },
      topGameDevelopers: {
        label: 'Top Advertisers',
        help: 'Top Advertisers',
        series: {
          cost: {
            label: 'Revenue',
            help: 'Top advertisers revenue for the selected period'
          },
        }
      },
    },
  },
  analyticsEmptyMessage: "Hey! Seems like we're missing some data to generate this widget. Contact your account manager to solve this ASAP!",

  // messageformat
  '#day': '{count, plural, one {1 day} other {# days}}',
  '#inLastDay': '{count, plural, one {in last day} other {in last # days}}',
  '#hours': '{count, plural, one {in an hour} other {# hours}}',
  '#player': '{count, plural, one {1 player} other {# players}}',
  '#user': '{count, plural, one {1 user} other {# users}}',

  // currencies
  USD: 'USD ($)',
  EUR: 'EUR (€)',

  // timeframe
  timeframe: 'Timeframe',
  presets: 'Presets',
  today: 'Today',
  yesterday: 'Yesterday',
  last7Days: 'Last 7 Days',
  last30Days: 'Last 30 Days',
  lifetime: 'lifetime',
  thisMonth: 'This Month',
  lastMonth: 'Last Month',
  customRange: 'Range',
  from: 'From',
  to: 'To',
  comparison: 'Comparison',
  comparisonPeriod: 'Comparison Period',
  reportingPeriod: 'Reporting Period',
  granularity: 'Granularity',
  hours: 'Hours',
  days: 'Days',
  weeks: 'Weeks',
  months: 'Months',

  //time periods

  sunday: 'Sunday',
  monday: 'Monday',
  tuesday: 'Tuesday',
  wednesday: 'Wednesday',
  thursday: 'Thursday',
  friday: 'Friday',
  saturday: 'Saturday',

  //ENGAGEMENT METRIC
  game_event_payment: 'App Event: Payment',
  clicked_on_ad: 'Clicked on an ad',
  game_event_progress: 'App Event: Payment',
  game_event_sessions_start: 'App Event: Sessions start',
  game_event_ad_revenue: 'Game Event: Ad Revenue',

  //UA METRIC
  game_event_new_player: 'App Event: New Player',

  //metrics
  seller_share: 'Revenue',

  // other
  accelerated: 'Accelerated',
  activate: 'Activate',
  activeUsers: 'Active Users',
  activatedUsers: 'Activated Users',
  activeDaysAMonth: 'Active days a month',
  activity: 'Activity',
  ad: 'Ad',
  advanced: 'Advanced',
  addToFilter: ' Add to filter',
  addSubRule: 'Add sub-rule',
  advertising_type: 'Advertising Type',
  audience_preview: 'Audience Preview',
  android: 'Android',
  removeFromFilter: 'Remove from filter',
  alignment: 'Alignment',
  all: 'all',
  allowAnonymousGames: 'Allow anonymous apps?',
  all_types: 'All Types',
  android_bundle_id: 'Android Bundle Id',
  android_postback: 'Android Impr. Postback',
  android_click_postback: 'Android Click Postback',
  android_impression_engagement_postback: 'Android AppsFlyer Impression URL',
  android_click_engagement_postback: 'Android AppsFlyer Click URL',
  android_click_after_complete_postback: 'Android Click After Complete Postback',
  global_postback: 'Global Impr. Postback',
  global_click_postback: 'Global Click Postback',
  global_click_engagement_postback: 'Global AppsFlyer Click URL',
  global_impression_engagement_postback: 'Global AppsFlyer Impression URL',
  global_click_after_complete_postback: 'Global Click After Complete Postback',
  applyChanges: 'Apply Changes',
  applyTo: 'Apply to',
  avg: 'AVG. {{value}}',
  avg_paid_amount: 'Avg. Payment Amount',
  activity_level: 'Activity level',
  avg_active_in_month: 'Users play on average {{value}} days per month',
  acquisition: 'Acquisition',
  app_open: 'App Open',
  app_open_rate: 'App Open Rate',
  backToLogin: 'Back to Login',
  backToDashboard: 'Back to Dashboard',
  banner_in_video: 'Banner In Video',
  bid_price: 'Bid Price',
  bid_prices: 'Bid Prices',
  blacklisted: 'Blacklisted',
  bundle: 'Bundle',
  branding: 'Branding',
  campaign_strategy_help: {
    accelerated: 'An accelerated FC will result a significant amount of impressions and higher costs. In order to avoid over exposure we recommend to have a weekly/ and monthly cap after x impressions. ',
    moderate: 'Recommend - A moderate FC will increase the times your ad is shown to users while avoiding over exposure and reducing the risk of high costs. ',
    limited: 'A limited FC will lower over exposure and significantly reduce (or restrict) the amount of times your ad is shown to users.'
  },
  cities: 'Cities',
  cities_edit_disabled: 'Cities selection is disabled due to too many items selected.',
  states: 'States',
  churnedUsers: 'Churned Users',
  click: 'Click',
  click_after_complete: 'Click After Complete',
  click_through_rate: 'CTR',
  cohort: 'Cohort',
  cohorts: 'Cohorts',
  copy_of: 'Copy of',
  config: 'Config',
  customField: 'Custom field',
  creative: 'Creative',
  creatives: 'Creatives',
  created: 'created',
  choose_api_from_list: 'Choose Api Framework',
  choose_end_card_from_list: 'Choose End Card',
  choose_segment: 'Choose Segment',
  choose_language_from_list: 'Choose Language',
  choose_os_from_list: 'Choose OS',
  choose_connection_type_from_list: 'Choose Connection Type',
  choose_device_id_type_from_list: 'Choose Device ID Type',
  choose_size_from_list: 'Choose size from list',
  choose_ssp_from_list: 'Choose SSP from list',
  change_password: 'Change Password',
  clickToChooseFromTheList: 'Click to choose from the list',
  currency: 'Currency',
  custom: 'Custom',
  clicked: 'Clicked',
  custom_values: 'Custom values',
  customizedBanner: 'Customized Banner',
  customizeNotSaved: 'Please save Campaign in order to customize this banner',
  color: 'Color',
  comparisons: 'Comparisons',
  comparisons_help: `
    * all quantative (gt,lt,eq...) can be combined
    * all quantative (gt,lt,eq...) can be defined only on field type integere/decimal
    * $exists can only be defined on string field types
    * if type is bool than only $eq allows (true/false)`,
  confirmChangingCurrency: 'Changing Currency can effect all campaigns and apps of this App Developer. Are you absolutely SURE!?',
  cr: 'CR',
  conversion_rate: 'Conversion rate',
  conversions: 'Conversions',
  createNew: 'Create New {{value}}',
  cross_promotion: 'Cross Promotion',
  cpqi: 'Cost',
  cpqi_help: 'Cost Per Quality Install. This is the estimated cost of users in the Marketplace, calculated based on their quality.',
  cpm: 'CPM',
  cpm_help: 'CPM.',
  daily: 'Daily',
  daily_budget: 'Daily Budget',
  daily_exploration_budget: 'Exploration Budget',
  dailyClicked_help: 'Unique users who clicked at least once',
  dailyTargeted_help: 'Number of unique users who were targeted a day',
  days_hours: 'Days / Hours',
  date: 'Date',
  desktop: 'Desktop',
  deviceType: 'Device type',
  deviceOS: 'Device OS',
  discontinue_campaign: 'Discontinue Campaign',
  dynamic_creative: 'Dynamic Creative',
  dont_start: 'Don\x27t Start',
  duplicate: 'Duplicate {{value}}',
  duplicateFrom: 'Duplicate from',
  duration: 'Duration',
  effectiveness: 'Effectiveness',
  editJson: 'Edit JSON',
  updateDynamicFields: 'Refresh Now',
  enabled: 'Enabled',
  ecpm: 'eCPM',
  ecpc: 'eCPC',
  ecpi: 'eCPI/O',
  ecpa: 'eCPA',
  engaged: 'Converted',
  engaged_players: 'Conversions',
  engagements: 'Conversions',
  explore: 'Explore',
  entries: 'Entries',
  exclude: 'Exclude',
  export: 'Export',
  ER_help: 'Conversion Rate (Converted / Daily Targeted)',
  false: 'False',
  field_label: 'Field Label',
  field_name: 'Field Name',
  field_type: 'Field Type',
  for: 'for',
  for_personalization: 'For personalization',
  for_encryption: 'For encryption',
  forgotYourPassword: 'Forgot your password',
  genresDevicesOS: 'Genres/Devices/OS',
  global: 'Global',
  help: 'Help',
  here: 'here',
  html_template: 'HTML Template',
  immediate: 'Immediate',
  impression: 'Impression',
  invalid: 'Invalid',
  inventory_apps_filter_policy: 'Inventory Apps Filter Policy',
  inventory_apps_filter_policy_help: 'Supports CSV file - single column without a header',
  installs: 'Installs',
  install_rate: 'Installs Rate',
  device_models_filter_policy: 'Device Models',
  device_models_filter_policy_help: 'Supports CSV file - single column without a header',
  device_models_all: 'Target all device models',
  device_models_block: 'Use exclusion list',
  device_models_allow: 'Use inclusion list',
  event_type: 'Event Type',
  ios: 'iOS',
  ios_postback: 'iOS Impr. Postback',
  ios_click_postback: 'iOS Click Postback',
  ios_impression_engagement_postback: 'iOS AppsFlyer Impression URL',
  ios_click_engagement_postback: 'iOS AppsFlyer Click URL',
  ios_click_after_complete_postback: 'iOS Click After Complete Postback',
  inLast: 'in last',
  ios_bundle_id: 'iOS Bundle Id',
  link: 'Link',
  links: 'Links',
  lastDays: 'last days',
  left: 'Left',
  letterSpacing: 'Letter Spacing',
  lineHeight: 'Line Height',
  livePreview: 'Live Preview',
  load: 'Load',
  logIn: 'Log in',
  marketplace: 'Marketplace',
  limited: 'Limited',
  location: 'Location',
  margin: 'Margin (%)',
  metric: 'Metric',
  middle: 'Middle',
  missing_creative_data: 'Missing Creative Data',
  moreFilters: 'More filters',
  mobile_browser: 'Mobile Browser',
  moderate: 'Moderate',
  mraid_playable: 'Mraid Playable',
  mraid_banner: 'Mraid Banner',
  mraid_dynamic: 'Mraid Dynamic',
  never: 'Never',
  native: 'Native',
  newly: 'Newly',
  newlyTargeted_help: 'Number of unique users who were targeted for the first time in the selected timeframe',
  nextUpdateIn: 'Next update in',
  newPlayers: 'New Users',
  newUsers: 'New Users',
  noAnonymousGames: 'No anonymous apps',
  noData: 'No Data',
  no: 'No',
  options: 'Options',
  payingAmount: 'Paying amount',
  payingAmount_help: 'The amount of payments users in the Marketplace paid in other apps.',
  payingPlayers: 'Paying Users',
  payingUsers: 'Paying Users',
  paying_users: 'Paying users',
  policy_filter_none: 'None',
  policy_filter_blacklist: 'Blacklist',
  policy_filter_whitelist: 'Whitelist',
  policy_filter_apps_count: 'apps selected',
  policy_filter_device_models_count: 'device models selected',
  players: 'Users',
  source: 'Source',
  viewAs: 'View as',
  targeted_players: 'Targeted Users',
  todaySoFar: 'Today so far',
  today_s: 'Today\'s',
  t_month_s: 'This Month\'s',
  total_stats: 'Total {{value}} Stats',
  total: 'Total',
  transactions: 'Transactions',
  ongoing: 'Ongoing',
  other: 'Other',
  others: 'Others',
  or: 'or',
  optional_field: '{{value}} (Optional)',
  operatingSystemOS: 'Operating System (OS)',
  overallStatistics: 'Overall statistics',
  segmentPerformanceStatistics: 'Segment Performance Statistics',
  segmentPerformanceStatisticsDesc: 'A quick overview on the performance of the segment in the marketplace',
  segmentAnalytics: 'Segment Analytics',
  segmentAnalyticsDesc: 'An overview on the users in the segment: size, where users come from, whats their value, etc',
  simplaexCampaignsAtAGlance: 'YouAppi DSP Campaigns at a Glance',
  affleCampaignsAtAGlance: 'mDSP Campaigns at a Glance',
  overview: '{{value}} overview',
  overwrite: 'Overwrite',
  pause: 'Pause {{value}}',
  paused: 'Paused',
  paused_due_to_budget: 'Paused due to budget',
  stop_reason_field_label: 'Stop reason',
  stop_reason_placeholder: 'Select a stop reason',
  stop_reason_budget_capped: 'The budget has capped - expected to resume soon',
  stop_reason_budget_ended: 'The budget has ended - not expected to resume soon',
  stop_reason_performance: 'Paused due to performance',
  stop_reason_creative_refresh: 'Creative refresh needed',
  stop_reason_flight_ended: 'Campaign flight ended',
  stop_reason_seasonality: 'Seasonality / off-peak period',
  stop_reason_advertiser_request: 'Advertiser request',
  stop_reason_technical_issue: 'Technical issue',
  stop_reason_internal_test: 'Internal test',
  budgetLimit: 'Budget Limit',
  payingPlayersOnlyQuestion: 'Paying users only?',
  payingUsersOnlyQuestion: 'Paying users only?',
  payingPlayersOnly: 'Paying users only',
  payingUsersOnly: 'Paying users only',
  notPaying: 'Not Paying',
  performance: 'Performance',
  playedForMoreThan: 'Played for more than',
  playersPlayed: 'Users Played',
  player_floor_price: 'User Floor Price',
  position: 'Position',
  possible_values_population: 'Possible values population',
  possible_values: 'Possible values',
  postback: 'Postback',
  publisher: 'Publisher',
  rank_as_buyer: 'Rank as Buyer',
  rank_as_buyer_help: 'a rank assigned to users from this app wants to buy when calculating their RPI/CPQI. High = 0.7, Low = 0.01',
  rank_as_seller: 'Rank as Seller',
  rank_as_seller_help: 'a rank assigned to users from this app when calculating their RPI/CPQI. High = 1.00, Low = 0.1',
  context: 'Context',
  context_help: '	For mobile apps, if a app is a mobile browser app, his value is low. this field is used when calculating users RPI/CPQI in marketplace.',
  rank: 'Rank',
  revenue: 'Revenue',
  replace: 'Replace',
  refresh: 'Refresh',
  reengagement: 'Reengagement',
  userAcquisition: 'User Acquisition',
  right: 'Right',
  installsConversionEvents: '30 days trend – Installs-to-Events - App',
  search: 'Search',
  searchForPlayers: 'Search for users',
  searchForUsers: 'Search for users',
  selling: 'Selling',
  serviceFees: 'Service Fees',
  second_auction_bid_help: 'In cases where we have multiple buyers in the marketplace trying to acquire the same user, we create a second auction where buyers can by how much to increase or reduce the bid for a popular user. Please use this field to determine how to handle your bids in cases like these. 0% value means there will be no special bids.',
  semantics: 'Semantics',
  semantics_help: `
    * swap,flip,append - each one must be alone - any combination of one of these that is greater than one is not valid.
    * counters/sum - lifetime/by_range_breakdown - only valid combinations are count+ count or sum+sum
    * sum_lifetime/by_range_breakdown - available only if field is integer/decimal`,
  shadow: 'Shadow',
  show: 'Show',
  showRows: 'Show rows',
  specific_date: 'Specific Date',
  spent: 'spent',
  success: 'Success',
  targeted: 'Targeted',
  targeting: 'Targeting',
  text: 'Text',
  textRotate: 'Text Angle',
  the: 'The',
  total_budget: 'Budget',
  tracking: 'Tracking',
  true: 'True',
  type: 'Type',
  updated: 'updated',
  unique: 'Unique',
  uniqueCTR_help: 'Rate of unique users that had a click (Daily Clicked / Daily Targeted)',
  uploadLogo: 'Upload Logo',
  up_to: 'up to',
  url_android_app_store: 'Android AppStore URL',
  url_web: 'Web URL',
  url_apple_app_store: 'iTunes AppStore URL',
  url_windows_app_store: 'Windows AppStore URL',
  user_acquisition: 'User Acquisition',
  value: 'Value',
  version: 'Version',
  video: 'Video',
  audio: 'Audio',
  volume_from: 'Volume from',
  volume_to: 'Volume to',
  variation_info: 'Select the language of the Variation',
  variation_start: 'Variation Start',
  variation_start_help: 'Variation Start',
  variation_end: 'Variation End',
  variation_end_help: 'Variation End',
  variation_status: 'Variation Status',
  campaign_to_variation_association: 'Select variations:',
  variation_to_campaign_association: 'Select campaigns:',
  yAxis: 'Y axis',
  yes: 'Yes',
  windows_phone: 'Windows Phone'
};



/** WEBPACK FOOTER **
 ** ./src/configs/localization/mapEN.js
 **/